import React from 'react';

const ComingSoonCard = ({ title, icon, description }) => {
  return (
    <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-8 border border-gold/20 text-center">
      {icon && (
        <div className="w-16 h-16 mx-auto mb-4 bg-gold/10 rounded-full flex items-center justify-center">
          <span className="text-3xl">{icon}</span>
        </div>
      )}
      <h2 className="text-2xl font-bold text-gold mb-3">{title}</h2>
      {description && <p className="text-gray-400 mb-4">{description}</p>}
      <span className="inline-block bg-gold text-dark px-4 py-2 rounded-full font-semibold text-sm">
        Coming Soon
      </span>
    </div>
  );
};

export default ComingSoonCard;
